import _ from 'lodash';

const transformResponse = (_response) => {
  const response = _.chain(_response);

  const transformGrade = ({ createdAt, score }) => ({
    score,
    createdAt: Date.parse(createdAt),
  });

  const fieldCollectionToObj = (fields) => (
    _.chain(fields).keyBy('fieldName').mapValues('fieldValue').value());

  const transformComponent = (component) => ({
    ...component,
    componentConfiguration: fieldCollectionToObj(component.componentConfigurationFields),
    parentConfiguration: fieldCollectionToObj(component.parentConfigurationFields),
  });

  const mapStudent = ({
    getLatestAttemptStudentManualGradeReport,
    account,
    ...studentNode
  }) => ({
    ...getLatestAttemptStudentManualGradeReport,
    ...account,
    ...account.identity,
    ...studentNode,
    grades: getLatestAttemptStudentManualGradeReport.grades.map(transformGrade),
  });

  const students = response.get('cohortById.enrollments.edges')
    .map(({ node }) => mapStudent(node))
    .keyBy('accountId').value();

  const components = response.get('cohortById.deployment.0.manualGradingComponents')
    .map(transformComponent)
    .keyBy('componentId').value();

  const ancestry = response.get('cohortById.deployment.0.interactive.ancestry')
    .value();

  return {
    students,
    components,
    ancestry,
  };
};

export { transformResponse };
